/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
export class PriceFormatKeyEventChecker {
    /**
     * @param {?} options
     */
    constructor(options) {
        this.options = {};
        this.updateOptions(options);
    }
    /**
     * @param {?} options
     * @return {?}
     */
    updateOptions(options) {
        this.options = options;
    }
}
function PriceFormatKeyEventChecker_tsickle_Closure_declarations() {
    /** @type {?} */
    PriceFormatKeyEventChecker.prototype.options;
}
